var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('color-picker',{ref:"picker",attrs:{"color":_vm.val || _vm.d},on:{"input":event => _vm.val = `rgba(${event.rgba.r}, ${event.rgba.g}, ${event.rgba.b}, ${event.rgba.a})`}}),(_vm.allowReset)?_c('span',{staticClass:"mt-2 block text-[#333333] underline text-[13px] cursor-pointer hover:opacity-80 line-height-[13px]",on:{"click":() => {
      _vm.val = _vm.defaultColor
      // eslint-disable-next-line vue/this-in-template
      this.reset()
    }}},[_vm._v(" Reset Color ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }